(function () {
  var intro = document.querySelector('[data-ta-luxury-intro]');
  if (!intro) return;

  if (!window.taLuxuryIntroShouldShow) {
    intro.remove();
    document.documentElement.classList.remove('ta-intro-will-show');
    return;
  }

  var duration = parseInt(intro.getAttribute('data-duration'), 10) || 2500;
  var closing = false;
  var removeTimer;

  function closeIntro() {
    if (closing) return;
    closing = true;
    window.clearTimeout(removeTimer);
    intro.classList.add('is-leaving');

    window.setTimeout(function () {
      document.documentElement.classList.remove('ta-intro-will-show');
      intro.remove();
    }, 780);
  }

  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      intro.classList.add('is-ready');
    });
  });

  removeTimer = window.setTimeout(closeIntro, duration);
  intro.addEventListener('click', closeIntro);
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) closeIntro();
  });
})();
